import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

import type { PostEmailIpWarmingStopResult } from "./types";

export const isPostEmailIpWarmingStopResult = objectOf<PostEmailIpWarmingStopResult>({
  success: boolean,
});
